import React, { FC } from 'react';

import { ScrollablePane } from 'office-ui-fabric-react';

import { ICustomScrollBarProps, ScrollBarSize } from './CustomScrollBar.types';
import { scrollBarSizes }                       from './constants';

import { CustomScrollBarWrapper } from './CustomScrollBar.styles';


export const CustomScrollBar: FC<ICustomScrollBarProps> = ({
                                                             children,
                                                             scrollbarVisibility = 'auto',
                                                             scrollBarSize = ScrollBarSize.Small,
                                                             isFading = true,
                                                             styles,
                                                           }) => {
  return (
    <CustomScrollBarWrapper size={scrollBarSizes[scrollBarSize]} styles={styles} isFading={isFading}>
      <ScrollablePane
        className="scrollable-pane"
        scrollbarVisibility={scrollbarVisibility}
        styles={{
          root: {
            fontSize: 'inherit',
            fontFamily: 'inherit',
            fontWeight: 'inherit',
          }
        }}
      >
        {children}
      </ScrollablePane>
    </CustomScrollBarWrapper>
  );
};